__turbopack_context__.v({
  "avatar": "zMDc6q_avatar",
  "contentGrid": "zMDc6q_contentGrid",
  "contentGridBody": "zMDc6q_contentGridBody",
  "contentGridTitle": "zMDc6q_contentGridTitle",
  "detailList": "zMDc6q_detailList",
  "employment": "zMDc6q_employment",
  "employments": "zMDc6q_employments",
  "list": "zMDc6q_list",
  "portfolio": "zMDc6q_portfolio",
  "portfolioBody": "zMDc6q_portfolioBody",
  "portfolioFigure": "zMDc6q_portfolioFigure",
  "portfolioImage": "zMDc6q_portfolioImage",
  "roleLogo": "zMDc6q_roleLogo",
  "roleTitle": "zMDc6q_roleTitle",
  "roleTitleCompany": "zMDc6q_roleTitleCompany",
  "roleTitlePos": "zMDc6q_roleTitlePos",
  "root": "zMDc6q_root",
  "top": "zMDc6q_top",
});
